import defaultTheme from '../theme/defaultTheme';
import { decryptData, encryptData } from './encryption';

const THEME_KEY = btoa('THEME_DATA');

export const storeThemeData = (data) => {
  const encryptedData = encryptData(JSON.stringify(data));
  window.localStorage.setItem(THEME_KEY, encryptedData);
};

export const getThemeData = () => {
  const jsonDataEncrypted = window.localStorage.getItem(THEME_KEY);
  const jsonData = decryptData(jsonDataEncrypted);
  return JSON.parse(jsonData);
};

export const removeThemeData = () => {
  window.localStorage.removeItem(THEME_KEY);
};

export const getItem = (key) => {
  try {
    const themeData = getThemeData();
    return themeData[key];
  }

  catch {
    return undefined;
  }
};

export const getLogo = () => {
  const logo = getItem('logo');
  return logo;
};

export const getTheme = () => {
  const theme = getItem('theme');
  return theme;
};

export const getDisableLogo = () => {
  const disableLogo = getItem('disableLogo');
  return disableLogo;
};

export const init = () => {
  const theme = getTheme();
  const logo = getLogo();
  const disableLogo = getDisableLogo();
  if (!logo || !theme) return { theme: defaultTheme, logo: '', disableLogo: true };
  return { logo, theme, disableLogo };
};
